<template>
	<label
		:class="[
			$style.container,
			color && $style[`container--bg-${color}`],
			density && $style[`container--density-${density}`],
			disabled && $style['container--disabled'],
		]"
	>
		<input
			type="radio"
			:name="name"
			:checked="checked"
			@change="onChange(value)"
		>
		<ao-icon
			:iconName="checked ? 'radio' : 'radioEmpty'"
			:class="$style.icon"
		/>
		<span class="ao-p2-regular ml-1">
			<slot>{{ label }}</slot>
		</span>
	</label>
</template>

<script>
export default {
	name: 'AoRadioBtn',

	props: {
		color: {
			type: String,
			default: 'primary',
			validate: (v) => ['primary', 'secondary'].includes(v), // FIXME: change to validator()
		},

		density: {
			type: String,
			default: 'default',
			validate: (v) => ['compact', 'comfortable', 'default'].includes(v), // FIXME: change to validator()
		},

		disabled: Boolean,

		label: [String, Number],

		value: {
			type: [String, Number, Boolean],
		},
	
		checked: {
			type: Boolean,
			default: false,
		},

		name: [String, Number], // for grouping
	},

	emits: ['update:modelValue'],

	methods: {
		onChange(value) {
			// console.log('onChange', value)
			this.$emit('update:modelValue', value)
		},
	},
}
</script>

<style module lang="scss">
$radio-height: 36px;

.container {
	position: relative;

	display: flex;
	align-items: center;
	cursor: pointer;

	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;

	//input:checked ~ .icon {
	//    color: rgb(var(--v-theme-primary));
	//}

	&--bg {
		&-primary {
			.icon {
				color: rgb(var(--v-theme-primary));
			}
		}
		&-secondary {
			.icon {
				color: rgb(var(--v-theme-on-secondary));
			}
		}
	}

	&--density {
		&-default {
			height: calc($radio-height);
		}

		&-compact {
			height: calc($radio-height - 12px);
		}

		&-comfortable {
			height: calc($radio-height - 8px);
		}
	}

	&--disabled {
		cursor: unset;
		pointer-events: none;

		& > * {
			opacity: 0.4;
		}
	}
}

.container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}
</style>
